module.exports = __webpack_public_path__ + "img/2024big10.985ca8d7.png";